module.exports = __webpack_public_path__ + "img/qiyejianjie.e49bb7e8.jpg";